module.exports = __webpack_public_path__ + "static/media/4.3de73831.png";